export const style = {
  boxShadow : {
    borderRadius: '5px',
    boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)'
  }
}